import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0H3C1.3 0 0 1.271 0 2.933v13.686c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.271 3-2.933V2.933C20 1.271 18.7 0 17 0m1 16.62c0 .586-.4.977-1 .977H3c-.6 0-1-.391-1-.978V2.933c0-.587.4-.978 1-.978h14c.6 0 1 .391 1 .978zm-4-7.822h-3V5.866c0-.587-.4-.978-1-.978s-1 .391-1 .978v2.932H6c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h3v2.932c0 .587.4.978 1 .978s1-.391 1-.978v-2.932h3c.6 0 1-.391 1-.978 0-.586-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }